import React from "react";
import { Route } from "react-router-dom";
import { Login } from "./Login";
import { Logout } from "./Logout";
import { ApplicationPaths, LoginActions, LogoutActions } from "./ApiAuthorizationConstants";

const loginAction = (name) => <Login action={name} />;
const logoutAction = (name) => <Logout action={name} />;

export default class ApiAuthorizationRoutes extends React.PureComponent {
    render(): JSX.Element {
        return (
            <>
                <Route
                    path={ApplicationPaths.Login}
                    render={() => loginAction(LoginActions.Login)}
                />
                <Route
                    path={ApplicationPaths.LoginFailed}
                    render={() => loginAction(LoginActions.LoginFailed)}
                />
                <Route
                    path={ApplicationPaths.LoginCallback}
                    render={() => loginAction(LoginActions.LoginCallback)}
                />
                <Route
                    path={ApplicationPaths.LogOut}
                    render={() => logoutAction(LogoutActions.Logout)}
                />
                <Route
                    path={ApplicationPaths.LogOutCallback}
                    render={() => logoutAction(LogoutActions.LogoutCallback)}
                />
                <Route
                    path={ApplicationPaths.LoggedOut}
                    render={() => logoutAction(LogoutActions.LoggedOut)}
                />
            </>
        );
    }
}
